


export enum ScriptStatusEnum {
	idle = 'idle',
	loading= 'loading',
	ready= 'ready',
	error= 'error',
}